import { AppBlock } from '@boost/widget-integration-tae/lib';
import { ModuleRefImpl } from 'framework/core';
import { Singleton } from 'framework/di';

import { CartController } from './cart.controller';
import { CartSelectors } from './cart.selectors';

@Singleton()
export class CartLifecycle {
  protected currentController: CartController | null = null;
  protected currentSelectors: CartSelectors | null = null;

  constructor(protected moduleRef: ModuleRefImpl) {}

  get controller(): CartController | null {
    return this.currentController;
  }

  get selectors(): CartSelectors | null {
    return this.currentSelectors;
  }

  async initialize(block: AppBlock): Promise<void> {
    if (!(block.document instanceof HTMLElement) || this.currentController) {
      return;
    }

    const [cartSelectors, controller] = await Promise.all([
      this.moduleRef.resolve<CartSelectors>(CartSelectors),
      this.moduleRef.resolve<CartController>(CartController),
    ]);

    await controller.connect();

    this.currentSelectors = cartSelectors;
    this.currentController = controller;
  }

  destroy(): void {
    this.currentController?.destroy();
    this.currentController = null;
    this.currentSelectors = null;
  }
}
